import { render, staticRenderFns } from "./pnsearch.vue?vue&type=template&id=95bc546e"
import script from "./pnsearch.vue?vue&type=script&lang=js"
export * from "./pnsearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports